export enum ContactEventType {
    AgentTypeChanged,
    ContactCreation,
    ContactCanLoginChanged,
    ContactUpdated
}

export class ContactHistoryEvent {
    timestamp: string;
    contactId: string = "";
    email: string = "";
    username: string = "";
    eventType: ContactEventType;
    eventDetails: string;
}